// extracted by mini-css-extract-plugin
export var bodySections = "_bf-8";
export var gray = "_bf-7";
export var green = "_bf-4";
export var iconContainer = "_bf-9";
export var iconWidgetContainer = "_bf-1";
export var phoneIcon = "_bf-2";
export var red = "_bf-5";
export var statusDot = "_bf-3";
export var widgetContainer = "_bf-0";
export var yellow = "_bf-6";